import script from "./product_stock.vue?vue&type=script&setup=true&lang=js"
export * from "./product_stock.vue?vue&type=script&setup=true&lang=js"

import "./product_stock.vue?vue&type=style&index=0&id=099b4f7c&lang=css"

const __exports__ = script;

export default __exports__